import { Badge } from "@/components/ui/badge";
import { CheckCircle2, XCircle, Smartphone, Clock } from "lucide-react";

const MAP = {
  afgeleverd: { l: "Afgeleverd", c: "bg-emerald-100 text-emerald-700", icon: CheckCircle2 },
  verzonden: { l: "Verzonden", c: "bg-emerald-50 text-emerald-700", icon: CheckCircle2 },
  niet_afgeleverd: { l: "Niet afgeleverd", c: "bg-red-100 text-red-700", icon: XCircle },
  mislukt: { l: "Mislukt", c: "bg-red-100 text-red-700", icon: XCircle },
  verstuurd_apparaat: { l: "Via apparaat verstuurd", c: "bg-slate-100 text-slate-600", icon: Smartphone },
  in_behandeling: { l: "In afwachting", c: "bg-amber-100 text-amber-700", icon: Clock },
};

export function DeliveryBadge({ status, channel, testId }) {
  const m = MAP[status];
  if (!m) return null;
  const Icon = m.icon;
  return (
    <Badge className={`${m.c} hover:${m.c} gap-1`} data-testid={testId}>
      <Icon className="h-3 w-3" />{m.l}{channel ? ` · ${String(channel).toUpperCase()}` : ""}
    </Badge>
  );
}
